import {createComponent} from "@front/utils/alpine";
import Swiper, {Navigation, Autoplay, SwiperOptions} from "swiper";

const feedbackCarousel = createComponent(() => ({
    init() {
        const swiperEl = this.$el.querySelector('.swiper') as HTMLElement;
        
        if (!swiperEl) {
            console.warn('Swiper element not found in feedback carousel');
            return;
        }

        const swiperClass = swiperEl.classList[1]; // Get the unique class like 'homefeedback-swiper-1'
        const id = swiperClass.split('-').pop(); // Extract the ID

        // Swiper 9 a besoin de suffisamment de slides pour boucler (≈ 2× le nombre
        // visible). S'il y en a trop peu, on duplique le contenu pour que le loop
        // infini tourne en continu même avec peu d'éléments.
        const wrapper = swiperEl.querySelector('.swiper-wrapper') as HTMLElement;
        if (wrapper) {
            const originalSlides = Array.from(wrapper.children);
            const minSlides = 9; // ~2× le max slidesPerView (4) + marge
            if (originalSlides.length > 1 && originalSlides.length < minSlides) {
                while (wrapper.children.length < minSlides) {
                    originalSlides.forEach((slide) => {
                        wrapper.appendChild(slide.cloneNode(true));
                    });
                }
            }
        }

        const config: SwiperOptions = {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            centeredSlides: false,
            slidesPerGroup: 1,
            navigation: {
                nextEl: `.homefeedback-next-${id}`,
                prevEl: `.homefeedback-prev-${id}`,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                }
            },
            watchSlidesProgress: true,
            on: {
                init: function(swiper) {
                    updateOpacity(swiper);
                },
                progress: function(swiper) {
                    updateOpacity(swiper);
                },
                setTranslate: function(swiper) {
                    updateOpacity(swiper);
                },
                breakpoint: function(swiper) {
                    updateOpacity(swiper);
                }
            }
        };

        function updateOpacity(swiper: any) {
            const slidesPerView = swiper.params.slidesPerView as number;
            const slides = swiper.slides as HTMLElement[];

            // Effet uniquement quand 4 slides sont visibles (desktop)
            if (typeof slidesPerView !== 'number' || slidesPerView < 4) {
                slides.forEach((slide: any) => {
                    slide.style.opacity = '1';
                    slide.style.transition = 'opacity 0.3s ease';
                });
                return;
            }

            // On s'appuie sur slide.progress (watchSlidesProgress), insensible aux
            // slides dupliqués du mode loop. Les slides visibles ont un |progress|
            // de 0 à 3 ; le centre de la fenêtre est à 1.5. On prend la valeur
            // absolue car le progress est négatif vers la droite selon le sens.
            // Les 2 slides centraux (|progress| 1 et 2 → distance 0.5) restent
            // pleins, les bords gauche/droite (|progress| 0 et 3 → distance 1.5)
            // sont atténués.
            const half = (slidesPerView - 1) / 2;

            slides.forEach((slide: any) => {
                const distance = Math.abs(Math.abs(slide.progress ?? 0) - half);
                let opacity = 1 - (distance - 0.5) * 0.6; // centre → 1, bords → 0.4
                opacity = Math.min(1, Math.max(0.4, opacity));
                slide.style.opacity = opacity.toFixed(2);
                slide.style.transition = 'opacity 0.3s ease';
            });
        }

        new Swiper(swiperEl, config);
    },
}));

export default feedbackCarousel;
